import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";
import React from "react";
import { IDataSet } from "../charts/interfaces";

interface IColumnTabWithMapperProps {
  value: number | string;
  valueDecimalPlaces: number;
  dataset: IDataSet;
}
export default function ColumnTabWithMapper({
  value,
  valueDecimalPlaces,
  dataset,
}: IColumnTabWithMapperProps) {
  const { data } = useGetDatasetMapperData(Number(dataset?.stringValueMapper) ?? "");
  const getNewValue = (value: number | string) => {
    let newValue: string | number = value;
    if (data?.mappings) {
      newValue = data.mappings[value] ?? value;
    }
    return newValue;
  };

  const newValue = getNewValue(value);

  return (
    <>
      {typeof newValue === "number"
        ? newValue.toFixed(valueDecimalPlaces)
        : typeof newValue === "string"
          ? newValue
          : "-"}
    </>
  );
}
